import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";
import Project1 from "../components/projects/Project1";
import Project2 from "../components/projects/Project2";
import Project3 from "../components/projects/Project3";
import Project4 from "../components/projects/Project4";
import Project5 from "../components/projects/Project5";
import Project6 from "../components/projects/Project6";
import Project7 from "../components/projects/Project7";
import Project8 from "../components/projects/Project8";
import Project9 from "../components/projects/Project9";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};


const Projects = () => {
  return (
    <section id="projects" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-yellow">PRO</span>JECTS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <p className="mt-10 mb-10">
          Please find below some of the projects I built.
        </p>
      </motion.div>

      {/* PROJECTS */}
      <div className="flex justify-center">
        <motion.div
          className="sm:grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* ROW 1 */}
          <div
            className="flex justify-center text-center items-center p-10 bg-gray-600
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          >
            BEAUTIFUL USER INTERFACES
          </div>

          <Project8/>
          <Project9/>

          {/* ROW 2 */}
          <Project3/>
          <Project4/>
          <Project5/>

          {/* ROW 3 */}
          <Project6/>
          <Project7/>
          <Project1/>
         
          {/* ROW 4 */}
          <Project2/>
          <div
            className="flex justify-center text-center items-center p-10 bg-blue
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          >
            SMOOTH USER EXPERIENCE
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
